// This is all you.
require("./bootstrap");

// Start Map Label
let maran = document.querySelector("#maran");
let cameronHighland = document.querySelector("#cameron-highland");
let bentong = document.querySelector("#bentong");
let lipis = document.querySelector("#lipis");
let raub = document.querySelector("#raub");
let jerantut = document.querySelector("#jerantut");
let kuantan = document.querySelector("#kuantan");
let temerloh = document.querySelector("#temerloh");
let rompin = document.querySelector("#rompin");
let bera = document.querySelector("#bera");
let pekan = document.querySelector("#pekan");

addLabelText(maran, "Maran");
addLabelText(cameronHighland, "Cameron");
addLabelText(cameronHighland, "Highland");
addLabelText(bentong, "Bentong");
addLabelText(lipis, "Lipis");
addLabelText(raub, "Raub");
addLabelText(jerantut, "Jerantut");
addLabelText(kuantan, "Kuantan");
addLabelText(temerloh, "Temerloh");
addLabelText(rompin, "Rompin");
addLabelText(bera, "Bera");
addLabelText(pekan, "Pekan");

function addLabelText(bgPath, labelText) {
    let bbox = bgPath.getBBox();
    let x = bbox.x + bbox.width / 2;
    let y = bbox.y + bbox.height / 2;

    // Create a <text> element
    let textElem = document.createElementNS(bgPath.namespaceURI, "text");
    // X axis
    if (labelText == "Bentong") {
        textElem.setAttribute("x", 286);
    } else if (labelText == "Pekan") {
        textElem.setAttribute("x", 870);
    } else if (labelText == "Cameron") {
        textElem.setAttribute("x", 75);
    } else {
        textElem.setAttribute("x", x);
    }
    // Y axis
    if (labelText == "Rompin") {
        textElem.setAttribute("y", 935);
    } else if (labelText == "Pekan") {
        textElem.setAttribute("y", 650);
    } else if (labelText == "Kuantan") {
        textElem.setAttribute("y", 440);
    } else if (labelText == "Cameron") {
        textElem.setAttribute("y", 130);
    } else if (labelText == "Highland") {
        textElem.setAttribute("y", 155);
    } else {
        textElem.setAttribute("y", y);
    }
    // Centre text horizontally at x,y
    textElem.setAttribute("text-anchor", "middle");
    // Give it a class that will determine the text size, colour, etc
    if (labelText == "Cameron" || labelText == "Highland") {
        textElem.classList.add("label-text-cameron");
    } else {
        textElem.classList.add("label-text");
    }
    // Set the text
    textElem.textContent = labelText;
    // Add this text element directly after the label background path
    bgPath.after(textElem);
}
// End Map Label

// Start nav Func
// window.onscroll = function () {
//     scrollFunction();
// };

// function scrollFunction() {
//     if (
//         document.body.scrollTop > 20 ||
//         document.documentElement.scrollTop > 20
//     ) {
//         document.getElementById("navbar").style.background = "#501e27";
//     } else {
//         document.getElementById("navbar").style.background = "none";
//     }
// }
// // End nav Func
